export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.ddb540c6.png";